import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { Line } from '@antv/g2plot';
import BaseChart from '../../components/base';
const LineChart = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(BaseChart, _extends({
    chart: Line,
    ref: ref
  }, props));
});
export default LineChart;